import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import SearchIcon from "../../../assets/CreateCategory/SeachIcon.svg";
import {
  useAddCategoryToMarketPlace,
  useGetAllCategorises,
} from "../../../hooks/useGuidelines";
import { message, Modal } from "antd";
import CreateCategory from "../CreateCategory";
import DebounceInput from "../../../common/DebounceInput";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";
const AddCategory = ({
  guide_selectedMarketPlaceId,
  setIsAddCategory,
  isCreateCategory,
  setIsCreateCategory,
  isCatgeoryAdded,
  categoryList,
}) => {
  const [search, setSearch] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [activeCategoryItem, setActiveCategoryItem] = useState();
  const [enabled, setEnabled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const {
    guide_setSelectedCategoryId,
    guide_selectedClientId,
    guide_setSelectedCategoryName,
  } = useContext(GuidelinesSelectedCategoryContext);

  useEffect(() => {
    if (categoryData.length > 0) {
      const initialCategory = categoryData[0];
      setActiveCategoryItem(initialCategory._id);
    }
  }, [categoryData]);

  const onSuccessGetAllCategories = (data) => {
    if (data?.status == 200) {
      setCategoryData(data?.data?.data);
    }
  };
  const onErrorGetAllCategories = () => {};
  const { data: getCategories, refetch: refetchListCategories } =
    useGetAllCategorises(
      "getAllCategories",
      pageNum,
      pageSize,
      search,
      onSuccessGetAllCategories,
      onErrorGetAllCategories
    );

  const handleCategoryCreated = (categoryName) => {
    setSelectedCategory(categoryName);
    sessionStorage.setItem("Category Created", categoryName);
  };

  useEffect(() => {}, [selectedCategory]);

  const onSuccessAddCategory = (res, payload) => {
    if (res?.status === 200) {
      message.success("Catgeory Added successfully");
      guide_setSelectedCategoryId(payload?.category);
      guide_setSelectedCategoryName(selectedCategoryName);
      setTimeout(() => {
        isCatgeoryAdded();
      });
    }
  };
  const categoryCreated = () => {
    setIsCreateCategory(false);
    refetchListCategories();
    setEnabled(false);
  };

  const onErrorAddCategory = () => {};

  const { mutate: addCategory } = useAddCategoryToMarketPlace(
    onSuccessAddCategory,
    onErrorAddCategory
  );

  const addCategoryHandler = () => {
    let payload = {
      category: activeCategoryItem,
      marketplace: guide_selectedMarketPlaceId,
      orgId: guide_selectedClientId,
    };
    addCategory(payload);
    setIsAddCategory(false);
  };

  // const toggleCategorySelection = (categoryId, isDisabled) => {
  //   if (isDisabled) return;

  //   setActiveCategoryItems((prev) => {
  //     if (prev.includes(categoryId)) {

  //       return prev.filter((id) => id !== categoryId);
  //     } else {

  //       return [...prev, categoryId];
  //     }
  //   });
  // };

  const getCreateCategoryModal = () => {
    return (
      <Modal
        title="Create Category"
        open={isCreateCategory}
        footer={null}
        width="60%"
        height="90dvh"
        className="create_subcategory_modal_wrapper"
        onCancel={() => setIsCreateCategory(false)}
      >
        <CreateCategory
          isCategoryCreated={categoryCreated}
          handleModalClose={() => setIsCreateCategory(false)}
          onCategoryCreated={handleCategoryCreated}
        />
      </Modal>
    );
  };

  return (
    <div className="add_category_main_wrapper">
      <div className="action_wrapper">
        <div className="search_wrapper">
          <DebounceInput
            searchName={search}
            setSearchName={setSearch}
            placeholder={"Search"}
            allowClear={true}
            showSearch={true}
          />
          {/* <input
            className="searchInput"
            placeholder="Search"
            name="search"
            value={search}
            onChange={handleSearch}
          /> */}
          <div className="searchIcon_wrapper">
            <img src={SearchIcon} alt="searchIcon" />
          </div>
        </div>
        <div className="action_btn">
          <button
            onClick={() => setIsCreateCategory(true)}
            className="createBtn"
          >
            {" "}
            Create Category
          </button>
          <button className="add_btn" onClick={addCategoryHandler}>
            Add
          </button>
        </div>
      </div>
      <div className="category_list">
        {categoryData
          ?.filter((data) => {
            return search?.toLowerCase() === ""
              ? data
              : data?.name?.toLowerCase()?.includes(search?.toLowerCase());
          })
          .map((category) => {
            const isDisabled = categoryList
              .map((item) => item._id)
              .includes(category._id);
            return (
              <div className={`box ${isDisabled ? "disabled" : ""}`}>
                {category?.image?.thumbPath?.url ? (
                  <div
                    className={`image_wrapper ${
                      activeCategoryItem === category?._id && !isDisabled
                        ? "active"
                        : sessionStorage.getItem("Category Created") ===
                          category?.name
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      if (!isDisabled) {
                        setActiveCategoryItem(category?._id);
                        setSelectedCategoryName(category?.name);
                      } else if (activeCategoryItem === category._id) {
                        setActiveCategoryItem(null);
                      }
                    }}
                  >
                    <img
                      src={category?.image?.thumbPath?.url}
                      alt={category?.name}
                    />
                  </div>
                ) : (
                  <div className="emptyContainer" />
                )}
                <span>{category?.name}</span>
              </div>
            );
          })}
      </div>
      {isCreateCategory && getCreateCategoryModal()}
    </div>
  );
};
export default AddCategory;
